// extracted by mini-css-extract-plugin
export default {"dialog":"dialogModal_dialog__ZiYTR"};